import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  grow: {
    flex: 1,
  },
}))

export default useStyles
